<template>
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-md-6">
					<div class="ibox">
						<div class="ibox-title">
							<h3>
								Felhasználó alapadatai
							</h3>
						</div>
						<div class="ibox-content">
							<table class="table">
								<tbody>
									<tr>
										<th>Név</th>
										<td>{{ user.name }}</td>
									</tr>
									<tr>
										<th>Email</th>
										<td>{{ user.email }}</td>
									</tr>
									<tr>
										<th>Anyja neve</th>
										<td>{{ user.mother_name }}</td>
									</tr>
									<tr>
										<th>Születési idő</th>
										<td>{{ user.birth_date }}</td>
									</tr>
									<tr>
										<th>Telefon</th>
										<td>{{ user.phone }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="col-6">
					<!-- itt volt az image upload -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			parent_model: 'User',
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	created() {
		this.$store.commit('updateSubTitle', 'Profil');
	},

};
</script>

<style></style>